var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      !_vm.planningLoad
        ? _c(
            "v-toolbar",
            { attrs: { height: "56" } },
            [
              _c("v-toolbar-title", [
                _vm._v("\n      " + _vm._s(_vm.bannerTitle) + "\n    ")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.planningLoad
        ? _c(
            "v-toolbar",
            {
              class: { "mobile-toolbar": _vm.isMobile },
              attrs: { height: "56" }
            },
            [
              _c("v-toolbar-title", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.planningLoad.humanId) +
                    ",\n      " +
                    _vm._s(
                      _vm._f("pluralize")(_vm.displayLoadCount, "truck", {
                        includeNumber: true
                      })
                    ) +
                    ",\n      " +
                    _vm._s(
                      _vm.distanceLabel(
                        _vm.planningLoad.loadGroup.details.loadedMiles
                      )
                    ) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  attrs: { slot: _vm.isMobile ? "extension" : null },
                  slot: _vm.isMobile ? "extension" : null
                },
                [
                  !_vm.isMobile ? _c("v-spacer") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-items",
                    [
                      !_vm.isMobile
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                small: "",
                                flat: "",
                                color: "primary",
                                loading: _vm.loading
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("reload")
                                }
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-icon", [_vm._v("refresh")]),
                                  _vm._v("\n            Reload\n          ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tabs",
                        {
                          attrs: {
                            right: !_vm.isMobile,
                            centered: _vm.isMobile,
                            grow: "",
                            "show-arrows": "",
                            color: "#f5f5f5",
                            "slider-color": "primary"
                          },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c(
                            "v-tab",
                            { key: "Details", attrs: { to: "#details" } },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "align-center",
                                  attrs: { column: "" }
                                },
                                [
                                  _c("v-icon", [_vm._v("list")]),
                                  _vm._v(
                                    "\n              Details\n            "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.showCustomerTab
                            ? _c(
                                "v-tab",
                                { key: "Customer", attrs: { to: "#customer" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "align-center",
                                      attrs: { column: "" }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("business")]),
                                      _vm._v(
                                        "\n              Customer\n            "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showBookedLoads
                            ? _c(
                                "v-tab",
                                { key: "Booked", attrs: { to: "#booked" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "align-center",
                                      attrs: { column: "" }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("event")]),
                                      _vm._v(" "),
                                      _vm.loadingBookedLoads
                                        ? _c("v-progress-linear", {
                                            staticClass: "mt-2 mb-0",
                                            attrs: { indeterminate: true }
                                          })
                                        : [
                                            _vm._v(
                                              "\n                Booked (" +
                                                _vm._s(_vm.bookedLoadsCount) +
                                                ")\n              "
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.planning
                            ? _c(
                                "v-tab",
                                { key: "Dispatch", attrs: { to: "#dispatch" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "align-center",
                                      attrs: { column: "" }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("share")]),
                                      _vm._v(
                                        "\n              Network\n            "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.planning && _vm.isLoadboardEnabled
                            ? _c(
                                "v-tab",
                                {
                                  key: "LiveLoadboard",
                                  attrs: { to: "#live_loadboard" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "align-center",
                                      attrs: { column: "" }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("gavel")]),
                                      _vm._v(
                                        "\n              Live Bids\n            "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.repeating
                            ? _c(
                                "v-tab",
                                {
                                  key: "ScheduleRepeatLoads",
                                  attrs: { to: "#schedule" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "align-center",
                                      attrs: { column: "" }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("sync")]),
                                      _vm._v(
                                        "\n              Schedule\n            "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            { key: "Map", attrs: { to: "#map" } },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "align-center",
                                  attrs: { column: "" }
                                },
                                [
                                  _c("v-icon", [_vm._v("map")]),
                                  _vm._v("\n              Map\n            ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pt-1", class: { "scroll-section": !_vm.isMobile } },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c(
                    "v-tab-item",
                    {
                      attrs: {
                        value: "details",
                        transition: false,
                        "reverse-transition": false
                      }
                    },
                    [
                      _vm.planningLoad
                        ? _c(
                            "v-edit-load-details",
                            {
                              attrs: {
                                company: _vm.company,
                                disableAddressView: _vm.disableAddressView,
                                dispatched: _vm.dispatched,
                                repeating: _vm.repeating,
                                "read-only": _vm.readOnly,
                                "planning-load": _vm.planningLoad
                              },
                              on: {
                                onFormChange: function($event) {
                                  return _vm.$emit("onFormChange", $event)
                                },
                                refresh: function($event) {
                                  return _vm.$emit("updateLoad", $event)
                                },
                                savingLoad: function($event) {
                                  return _vm.$emit("savingLoad", $event)
                                }
                              }
                            },
                            [
                              _c(
                                "v-toolbar-items",
                                {
                                  attrs: { slot: "toolbarItems" },
                                  slot: "toolbarItems"
                                },
                                [_vm._t("toolbarButtons")],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showCustomerTab
                    ? _c(
                        "v-tab-item",
                        {
                          attrs: {
                            value: "customer",
                            transition: false,
                            "reverse-transition": false
                          }
                        },
                        [
                          _c("company-settings", {
                            attrs: {
                              "prop-company-id":
                                _vm.planningLoad.loadGroup.details
                                  .customerCompany.id
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showBookedLoads
                    ? _c(
                        "v-tab-item",
                        {
                          attrs: {
                            value: "booked",
                            transition: false,
                            "reverse-transition": false
                          }
                        },
                        [
                          _vm.company && _vm.planningLoad
                            ? _c("v-booked", {
                                class: { "pl-2": !_vm.isMobile },
                                attrs: {
                                  planningLoad: _vm.planningLoad,
                                  "covered-loads": _vm.groupBookedLoads,
                                  company: _vm.company,
                                  loading: _vm.loading
                                },
                                on: {
                                  reload: function($event) {
                                    return _vm.$emit("cancelLoad", $event)
                                  },
                                  assignMyTrucks: function($event) {
                                    return _vm.$confirm(
                                      "assign the trucks already"
                                    )
                                  },
                                  refreshLoad: function($event) {
                                    return _vm.$emit("reload", $event)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.planning
                    ? _c(
                        "v-tab-item",
                        {
                          attrs: {
                            lazy: "",
                            value: "dispatch",
                            transition: false,
                            "reverse-transition": false
                          }
                        },
                        [_vm._t("dispatchTab")],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoadboardEnabled && _vm.planning
                    ? _c(
                        "v-tab-item",
                        {
                          attrs: {
                            lazy: "",
                            value: "live_loadboard",
                            transition: false,
                            "reverse-transition": false
                          }
                        },
                        [_vm._t("liveLoadBoardTab")],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.repeating
                    ? _c(
                        "v-tab-item",
                        {
                          attrs: {
                            lazy: "",
                            value: "schedule",
                            transition: false,
                            "reverse-transition": false
                          }
                        },
                        [
                          _vm.planningLoad
                            ? _c("v-schedule-repeat-loads", {
                                attrs: { load: _vm.planningLoad },
                                on: {
                                  refresh: function($event) {
                                    return _vm.$emit("updateLoad", $event)
                                  },
                                  dirty: function($event) {
                                    return _vm.$emit("onFormChange", $event)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    {
                      attrs: {
                        value: "map",
                        lazy: "",
                        transition: false,
                        "reverse-transition": false
                      }
                    },
                    [
                      _vm._t("loadMap", function() {
                        return [
                          _vm.planningLoad
                            ? _c("load-map", {
                                staticClass: "py-1 px-1",
                                attrs: {
                                  disableZoom: _vm.disableAddressView,
                                  hideOnSmall: "",
                                  "origin-place-id": _vm._.get(
                                    _vm.planningLoad,
                                    "loadGroup.details.pickupLocation.googlePlace.placeId",
                                    null
                                  ),
                                  "destination-place-id": _vm._.get(
                                    _vm.planningLoad,
                                    "loadGroup.details.dropoffLocation.googlePlace.placeId",
                                    null
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e41fc6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e41fc6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/simple/LoadGroupDetails.vue
// module id = null
// module chunks = 